import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { toggleReaction } from "../../store/actions/actions.reactions.jsx";

export const useToggleReaction = (parentType, parentId) => {
  const dispatch = useDispatch();

  const toggle = useCallback(
    (type) => {
      dispatch(toggleReaction(type, parentType, parentId));
    },
    [dispatch, parentId, parentType]
  );

  return toggle;
};
